import React from 'react';
import { compose } from 'redux';

import { Row } from '../../Structure';
import { withApplicantData } from '../../../hocs/withData';


const ApplicantAddressContent = ({
  ApplicantData = {},
}) => {
  const {
    addressLine1 = '',
    addressLine2 = '',
    addressLine3 = '',
    addressLine4 = '',
    homePostcode = '',
  } = ApplicantData;

  return (
    <div className="home-address">
      <h3>
        Home Address:
      </h3>
      <Row>
        <span>
          {addressLine1}
        </span>
        <span>
          {addressLine2}
        </span>
        <span>
          {addressLine3}
        </span>
        <span>
          {addressLine4}
        </span>
        <span>
          {homePostcode}
        </span>
      </Row>
    </div>
  );
};

export default compose(
  withApplicantData,
)(ApplicantAddressContent);
